module.exports = __webpack_public_path__ + "img/logo-new.9a59761d.png";